module.exports = __webpack_public_path__ + "c45236231dea37e33ccf539e37822519.woff2";